import GlobalConstImport from "../constants/GlobalConst";
const GlobalConst = GlobalConstImport.default ?? GlobalConstImport;

let baseWager = 5.0;
if (GlobalConst.SITE_CURRENCY === "US")
    baseWager = 5.0;
else if (GlobalConst.SITE_CURRENCY === "MXN")
    baseWager = 50.0

class Pick16PayoutCalculator {
    static TotalTrials = 16;
    static BaseWager = baseWager;

    static Probabilities = {
        // k=0
        "0-0": 0.04, "0-1": 0.04, "0-2": 0.05, "0-3": 0.07,
        "0-4": 0.11, "0-5": 0.17, "0-6": 0.25, "0-7": 0.36,
        "0-8": 0.50, "0-9": 0.66, "0-10": 0.81, "0-11": 0.94,
        "0-12": 1.00, "0-13": 1.00, "0-14": 1.00, "0-15": 1.00,

        // k=1
        "1-0": 0.06, "1-1": 0.04, "1-2": 0.02, "1-3": 0.02,
        "1-4": 0.03, "1-5": 0.05, "1-6": 0.09, "1-7": 0.14,
        "1-8": 0.23, "1-9": 0.34, "1-10": 0.50, "1-11": 0.69,
        "1-12": 0.88, "1-13": 1.00, "1-14": 1.00, "1-15": 1.00,

        // k=2
        "2-0": 0.09, "2-1": 0.05, "2-2": 0.02, "2-3": 0.01,
        "2-4": 0.01, "2-5": 0.02, "2-6": 0.04, "2-7": 0.06,
        "2-8": 0.11, "2-9": 0.19, "2-10": 0.31, "2-11": 0.50,
        "2-12": 0.75, "2-13": 1.00, "2-14": 1.00, "2-15": 0.00,

        // k=3
        "3-0": 0.13, "3-1": 0.07, "3-2": 0.03, "3-3": 0.01,
        "3-4": 0.004, "3-5": 0.004, "3-6": 0.01, "3-7": 0.02,
        "3-8": 0.03, "3-9": 0.06, "3-10": 0.13, "3-11": 0.25,
        "3-12": 0.50, "3-13": 1.00, "3-14": 0.00, "3-15": 0.00,

        // k=4
        "4-0": 0.19, "4-1": 0.11, "4-2": 0.05, "4-3": 0.02,
        "4-4": 0.004, "4-5": 0.00, "4-6": 0.00, "4-7": 0.00,
        "4-8": 0.00, "4-9": 0.00, "4-10": 0.00, "4-11": 0.00,
        "4-12": 0.00, "4-13": 0.00, "4-14": 0.00, "4-15": 0.00,

        // k=5
        "5-0": 0.27, "5-1": 0.17, "5-2": 0.09, "5-3": 0.04,
        "5-4": 0.008, "5-5": 0.00, "5-6": 0.00, "5-7": 0.00,
        "5-8": 0.00, "5-9": 0.00, "5-10": 0.00, "5-11": 0.00,
        "5-12": 0.00, "5-13": 0.00, "5-14": 0.00, "5-15": 0.00,

        // k=6
        "6-0": 0.38, "6-1": 0.25, "6-2": 0.14, "6-3": 0.06,
        "6-4": 0.02, "6-5": 0.00, "6-6": 0.00, "6-7": 0.00,
        "6-8": 0.00, "6-9": 0.00, "6-10": 0.00, "6-11": 0.00,
        "6-12": 0.00, "6-13": 0.00, "6-14": 0.00, "6-15": 0.00,

        // k=7
        "7-0": 0.50, "7-1": 0.36, "7-2": 0.23, "7-3": 0.11,
        "7-4": 0.03, "7-5": 0.00, "7-6": 0.00, "7-7": 0.00,
        "7-8": 0.00, "7-9": 0.00, "7-10": 0.00, "7-11": 0.00,
        "7-12": 0.00, "7-13": 0.00, "7-14": 0.00, "7-15": 0.00,

        // k=8
        "8-0": 0.64, "8-1": 0.50, "8-2": 0.34, "8-3": 0.19,
        "8-4": 0.06, "8-5": 0.00, "8-6": 0.00, "8-7": 0.00,
        "8-8": 0.00, "8-9": 0.00, "8-10": 0.00, "8-11": 0.00,
        "8-12": 0.00, "8-13": 0.00, "8-14": 0.00, "8-15": 0.00,

        // k=9
        "9-0": 0.77, "9-1": 0.66, "9-2": 0.50, "9-3": 0.31,
        "9-4": 0.13, "9-5": 0.00, "9-6": 0.00, "9-7": 0.00,
        "9-8": 0.00, "9-9": 0.00, "9-10": 0.00, "9-11": 0.00,
        "9-12": 0.00, "9-13": 0.00, "9-14": 0.00, "9-15": 0.00,

        // k=10
        "10-0": 0.89, "10-1": 0.81, "10-2": 0.69, "10-3": 0.50,
        "10-4": 0.25, "10-5": 0.00, "10-6": 0.00, "10-7": 0.00,
        "10-8": 0.00, "10-9": 0.00, "10-10": 0.00, "10-11": 0.00,
        "10-12": 0.00, "10-13": 0.00, "10-14": 0.00, "10-15": 0.00,

        // k=11
        "11-0": 0.97, "11-1": 0.94, "11-2": 0.88, "11-3": 0.75,
        "11-4": 0.50, "11-5": 0.00, "11-6": 0.00, "11-7": 0.00,
        "11-8": 0.00, "11-9": 0.00, "11-10": 0.00, "11-11": 0.00,
        "11-12": 0.00, "11-13": 0.00, "11-14": 0.00, "11-15": 0.00,

        // k=12
        "12-0": 1.00, "12-1": 1.00, "12-2": 1.00, "12-3": 1.00,
        "12-4": 1.00, "12-5": 0.00, "12-6": 0.00, "12-7": 0.00,
        "12-8": 0.00, "12-9": 0.00, "12-10": 0.00, "12-11": 0.00,
        "12-12": 0.00, "12-13": 0.00, "12-14": 0.00, "12-15": 0.00,

        // k=13
        "13-0": 1.00, "13-1": 1.00, "13-2": 1.00, "13-3": 1.00,
        "13-4": 0.00, "13-5": 0.00, "13-6": 0.00, "13-7": 0.00,
        "13-8": 0.00, "13-9": 0.00, "13-10": 0.00, "13-11": 0.00,
        "13-12": 0.00, "13-13": 0.00, "13-14": 0.00, "13-15": 0.00,

        // k=14
        "14-0": 1.00, "14-1": 1.00, "14-2": 1.00, "14-3": 0.00,
        "14-4": 0.00, "14-5": 0.00, "14-6": 0.00, "14-7": 0.00,
        "14-8": 0.00, "14-9": 0.00, "14-10": 0.00, "14-11": 0.00,
        "14-12": 0.00, "14-13": 0.00, "14-14": 0.00, "14-15": 0.00,

        // k=15
        "15-0": 1.00, "15-1": 1.00, "15-2": 0.00, "15-3": 0.00,
        "15-4": 0.00, "15-5": 0.00, "15-6": 0.00, "15-7": 0.00,
        "15-8": 0.00, "15-9": 0.00, "15-10": 0.00, "15-11": 0.00,
        "15-12": 0.00, "15-13": 0.00, "15-14": 0.00, "15-15": 0.00,

        // k=16
        "16-0": 1.00, "16-1": 0.00, "16-2": 0.00, "16-3": 0.00,
        "16-4": 0.00, "16-5": 0.00, "16-6": 0.00, "16-7": 0.00,
        "16-8": 0.00, "16-9": 0.00, "16-10": 0.00, "16-11": 0.00,
        "16-12": 0.00, "16-13": 0.00, "16-14": 0.00, "16-15": 0.00,
    };
    static getWinningProbability(k, r) {
        return this.Probabilities[`${k}-${r}`];
    }

    HardcodedPayoutsUSD = [
        500, 50, 10, 5, 0, 0, 0, 0, 0, 0, 0, 0, 5, 10, 50, 250, 40000
    ];

    HardcodedPayoutsMXN = [
        5000,    // 0 correct
        500,     // 1 correct
        100,     // 2 correct
        50,      // 3 correct
        0,       // 4 correct
        0,       // 5 correct
        0,       // 6 correct
        0,       // 7 correct
        0,       // 8 correct
        0,       // 9 correct
        0,       // 10 correct
        0,       // 11 correct
        50,      // 12 correct
        100,     // 13 correct
        500,     // 14 correct
        2500,    // 15 correct
        400000   // 16 correct
    ];

    // Method to calculate distribution
    calculateDistribution(wager, rollingPayout = 0.0) {
        const resultTable = [];
        let payouts = [];
        if(GlobalConst.SITE_CURRENCY === "US") payouts = this.HardcodedPayoutsUSD;
        else if(GlobalConst.SITE_CURRENCY === "MXN") payouts = this.HardcodedPayoutsMXN;
        for (let successes = 0; successes <= Pick16PayoutCalculator.TotalTrials; successes++) {
            let adjustedPayout = (payouts[successes] * wager) / Pick16PayoutCalculator.BaseWager;

            if (successes === Pick16PayoutCalculator.TotalTrials) {
                adjustedPayout += rollingPayout;
            }

            resultTable.push({
                correct: successes,
                total: Pick16PayoutCalculator.TotalTrials,
                multiplier:  adjustedPayout/wager,
                payout: adjustedPayout
            });
        }

        return resultTable;
    }
}

export default Pick16PayoutCalculator;
